import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../../utils/supabaseClient';

function Signup() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const navigate = useNavigate();

  const handleSignup = async (e) => {
    e.preventDefault();
    setErrorMsg('');

    if (!name.trim()) {
      setErrorMsg('Please enter your name.');
      return;
    }

    if (password.length < 8) {
      setErrorMsg('Password must be at least 8 characters long.');
      return;
    }

    const { error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        emailRedirectTo: 'https://cici-nine.vercel.app/create',
        data: { name }, // ✨ send name in metadata
      },
    });

    if (error) {
      setErrorMsg(error.message);
      return;
    }

    setSubmitted(true);
    navigate('/account-created');
  };

  const generatePassword = () => {
    const chars =
      'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_-+=<>?';
    let generated = '';
    for (let i = 0; i < 12; i++) {
      generated += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setPassword(generated);
    setShowPassword(true);
  };

  return (
    <section className="auth-page contain contain-smaller align-middle">
      <h1>Create an account</h1>

      <form onSubmit={handleSignup}>
        <label htmlFor="name">Your Name:</label>
        <input
          type="text"
          id="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          disabled={submitted}
        />

        <label htmlFor="email">Email Address:</label>
        <input
          type="email"
          id="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          disabled={submitted}
        />

        <div className="user-password">
          <label htmlFor="password">Password:</label>
          {errorMsg && <p className="error-msg">{errorMsg}</p>}

          <div className="password-input-wrapper" style={{ position: 'relative' }}>
            <input
              type={showPassword ? 'text' : 'password'}
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={submitted}
            />
            <span
              className="toggle-view-pw"
              onClick={() => setShowPassword(!showPassword)}
              style={{ cursor: 'pointer' }}
            >
              <i
                className={`bi ${
                  showPassword ? 'bi-eye-slash-fill' : 'bi-eye-fill'
                }`}
              ></i>
            </span>
          </div>

          {!submitted && (
            <button
              type="button"
              className="link-text generate-password-btn"
              onClick={generatePassword}
            >
              Generate a strong password
            </button>
          )}
        </div>

        <div className="text-center">
          <button type="submit" className="btn mt-0" disabled={submitted}>
            Continue
          </button>
        </div>
      </form>

      <div>
        <p>
          Already have an account?{' '}
          <a href="/" className="link-text">
            Log in
          </a>
        </p>
      </div>

      <div className="legal-links">
        <p className="text-center">
          By continuing, you agree to the <br />
          <a href="/legal.html#terms-of-use" className="primary-text">
            Terms of Use
          </a>{' '}
          &{' '}
          <a href="/legal.html#privacy-policy" className="primary-text">
            Privacy Policy
          </a>
        </p>
      </div>
    </section>
  );
}

export default Signup;
